import { getProviderWithCreditCards } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/credit-cards';

export default async ({ $apolloQuery, route, store }) => {
  await $apolloQuery(getProviderWithCreditCards, { slug: route.params.provider }).then(provider => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const description = store.$i18n.t('provider.description', { provider: provider.name });
    const title = store.$i18n.t('provider.jumbotron.title', { provider: provider.name });
    store.commit('pageContent/setHead', { title, description });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/banking', '/money/'],
      ['i18n/cards', '/compare-credit-cards/'],
      ['i18n/providers', '/compare-credit-cards/providers/'],
      provider.name
    ]);
    store.commit('blog/setList', provider.articles);
    store.commit('products/setList', provider.credit_cards);
    delete provider.articles;
    delete provider.credit_cards;
    store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
    store.commit('providers/set', provider);
  });
};
